import React from 'react';
import { Container } from 'swag-client-common/components/ui/container';
import Page from '../../../page';
import { ProfileLinks } from './components/profile-links';
import classes from './profile.scss';
export const Profile = ({
  children,
  passwordNotSet
}) => {
  return /*#__PURE__*/React.createElement(Page, {
    showCategories: false,
    doNotUseSticky: true
  }, /*#__PURE__*/React.createElement(ProfileLinks, {
    passwordNotSet: passwordNotSet
  }), /*#__PURE__*/React.createElement(Container, {
    innerClassName: classes.innerContainer
  }, children));
};